<div class="show-qr-container">
  <h2>QR Árbitro</h2>

  <div class="info-match">
    <div><strong>{{player1Name}}</strong> vs <strong>{{player2Name}}</strong></div>
    <div>Cancha {{match.court || '?'}} · {{match.category}}</div>
    <div *ngIf="match.code">Código: <strong>{{match.code}}</strong></div>
  </div>

  <div class="qr" *ngIf="match.code && qrConfig">
    <ngx-qrcode-styling
      [config]="qrConfig"
      [template]="qrConfig.template">
    </ngx-qrcode-styling>
  </div>

  <div class="no-code" *ngIf="!match.code">
    Este partido no tiene código asignado
  </div>

  <div class="buttons">
    <button mat-stroked-button (click)="close()">Cerrar</button>
  </div>
</div>
